import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { isDefined, isSSR } from 'wix-rich-content-common';
import { s as styleInject } from './style-inject.es-e7b07dd7.js';
import IframePlayer from './IframePlayer.js';
import { ReactPlayerWrapper } from './reactPlayerWrapper.js';

var css_248z = ".nmUev{height:100%;position:absolute;top:0;width:100%;z-index:0}[dir] .nmUev{border:0}[dir=ltr] .nmUev{left:0}[dir=rtl] .nmUev{right:0}.suQxS{bottom:0;position:absolute;top:0;z-index:3}[dir=ltr] .suQxS,[dir=rtl] .suQxS{left:0;right:0}.n9VC8{height:0;position:relative}[dir] .n9VC8{padding-bottom:56.25%}@supports not (contain:inline-size){@media only screen and (max-width:640px){.n9VC8{min-width:auto}}}@container (width < 640px){.n9VC8{min-width:auto}}";
var styles = {"video_player":"nmUev","videoOverlay":"suQxS","video_container":"n9VC8"};
styleInject(css_248z);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
class VideoViewer extends Component {
  constructor(props) {
    super(props);
    this.getInitialUrlState = () => {
      const { src } = this.props.componentData.video || {};
      if (src == null ? void 0 : src.url) {
        const normalizedUrl = this.normalizeUrl(src.url);
        return {
          type: "READY",
          loadedUrl: normalizedUrl
        };
      }
      if ((src == null ? void 0 : src.id) && this.props.settings.getVideoUrl) {
        try {
          const videoUrl = this.props.settings.getVideoUrl({ pathname: src.id });
          if (typeof videoUrl === "string") {
            return {
              type: "READY",
              loadedUrl: this.normalizeUrl(videoUrl),
              startingId: src.id
            };
          }
          return { type: "INITIAL" };
        } catch (e) {
          return { type: "INITIAL" };
        }
      }
      return { type: "INITIAL" };
    };
    this.setUrl = async () => {
      const { src } = this.props.componentData.video || {};
      const currentUrl = this.state.url;
      if (currentUrl.type === "LOADING") {
        return;
      }
      if (src == null ? void 0 : src.url) {
        const normalizedUrl = this.normalizeUrl(src.url);
        if (currentUrl.type === "READY" && currentUrl.loadedUrl === normalizedUrl) {
          return;
        }
        this.setState({
          url: {
            type: "READY",
            loadedUrl: normalizedUrl
          }
        });
        return;
      }
      if ((src == null ? void 0 : src.id) && this.props.settings.getVideoUrl) {
        if (currentUrl.type === "READY" && currentUrl.startingId === src.id) {
          return;
        }
        this.setState({ url: { type: "LOADING" } });
        try {
          const videoUrl = await this.props.settings.getVideoUrl({ pathname: src.id });
          this.setState({
            url: {
              type: "READY",
              loadedUrl: this.normalizeUrl(videoUrl),
              startingId: src.id
            }
          });
          return;
        } catch (e) {
          this.setState({ url: { type: "READY", startingId: src.id } });
          return;
        }
      }
      if (currentUrl.type !== "READY") {
        this.setState({ url: { type: "READY" } });
      }
    };
    this.normalizeUrl = (url) => url && (url.toLowerCase().indexOf("vimeo") === 0 ? "https://" + url : url);
    //vimeo player needs urls prefixed with http[s]
    this.findFormalVideoRatio = (ratio) => {
      const baseRatios = [1, 5 / 4, 4 / 3, 3 / 2, 16 / 10, 16 / 9, 1.85, 2, 2.35, 2.39, 3];
      const videoRatios = [...baseRatios, ...baseRatios.map((x) => 1 / x)];
      const findClosest = (arr, target) => arr.reduce((prev, curr) => Math.abs(curr - target) < Math.abs(prev - target) ? curr : prev);
      const closest = findClosest(videoRatios, ratio);
      return Math.abs(closest - ratio) > 0.01 ? ratio : closest;
    };
    /**
     * A bit confusing to understand at first, but the idea is that at first
     * you let the parent control "isLoaded" state for themselves and if they do not
     * want to do that, control it here.
     */
    this.onReactPlayerReady = (player) => {
      if (this.props.onReady) {
        this.props.onReady(player);
        return;
      }
      if (!this.props.isLoaded) {
        this.setState({ isLoaded: true });
      }
    };
    this.handleContextMenu = (e) => this.props.componentData.disableDownload && e.preventDefault();
    this.disableDownloadProps = () => {
      const { componentData, settings } = this.props;
      if (isDefined(componentData == null ? void 0 : componentData.disableDownload) && componentData.disableDownload || isDefined(settings == null ? void 0 : settings.disableDownload) && settings.disableDownload) {
        return {
          config: {
            file: {
              attributes: {
                controlsList: "nodownload"
              }
            }
          }
        };
      }
      return {
        config: {}
      };
    };
    this.onProgress = (progress) => {
      var _a;
      const { settings, nodeId } = this.props;
      (_a = settings.onProgress) == null ? void 0 : _a.call(settings, __spreadProps(__spreadValues({}, progress), { id: nodeId }));
    };
    this.getInitialThumbnailUrlState = () => {
      var _a, _b, _c, _d;
      const { componentData } = this.props;
      const thumbnailId = (_b = (_a = componentData == null ? void 0 : componentData.thumbnail) == null ? void 0 : _a.src) == null ? void 0 : _b.id;
      const thumbnailSrc = (_d = (_c = componentData == null ? void 0 : componentData.thumbnail) == null ? void 0 : _c.src) == null ? void 0 : _d.url;
      if (thumbnailSrc) {
        return {
          type: "READY",
          loadedUrl: thumbnailSrc
        };
      }
      if (!thumbnailId || !this.props.settings.getThumbnailUrl) {
        return { type: "INITIAL" };
      }
      try {
        const thumbnailUrl = this.props.settings.getThumbnailUrl({ pathname: thumbnailId });
        if (typeof thumbnailUrl === "string") {
          return {
            type: "READY",
            loadedUrl: thumbnailUrl,
            startingId: thumbnailId
          };
        }
      } catch (e) {
        return { type: "INITIAL" };
      }
      return { type: "INITIAL" };
    };
    this.setThumbnailUrl = async () => {
      var _a, _b, _c, _d;
      const { componentData } = this.props;
      const thumbnailId = (_b = (_a = componentData == null ? void 0 : componentData.thumbnail) == null ? void 0 : _a.src) == null ? void 0 : _b.id;
      const thumbnailSrc = (_d = (_c = componentData == null ? void 0 : componentData.thumbnail) == null ? void 0 : _c.src) == null ? void 0 : _d.url;
      const thumbnailState = this.state.thumbnailUrl;
      if (thumbnailSrc) {
        if (this.state.thumbnailUrl.type === "READY" && thumbnailSrc === this.state.thumbnailUrl.loadedUrl) {
          return;
        }
        this.setState({
          thumbnailUrl: {
            type: "READY",
            loadedUrl: thumbnailSrc
          }
        });
        return;
      }
      if (thumbnailState.type === "LOADING") {
        return;
      }
      if (!thumbnailId) {
        if (thumbnailState.type === "INITIAL") {
          this.setState({ thumbnailUrl: { type: "READY" } });
        }
        return;
      }
      if (!this.props.settings.getThumbnailUrl) {
        if (thumbnailState.type === "INITIAL" || thumbnailState.type === "READY" && thumbnailState.startingId !== thumbnailId) {
          this.setState({ thumbnailUrl: { type: "READY", startingId: thumbnailId } });
        }
        return;
      }
      if (thumbnailState.type === "READY" && thumbnailState.startingId === thumbnailId && !!thumbnailState.loadedUrl) {
        return;
      }
      try {
        this.setState({ thumbnailUrl: { type: "LOADING" } });
        const thumbnailUrl = await this.props.settings.getThumbnailUrl({ pathname: thumbnailId });
        this.setState({
          thumbnailUrl: {
            type: "READY",
            loadedUrl: thumbnailUrl,
            startingId: thumbnailId
          }
        });
      } catch (e) {
        this.setState({ thumbnailUrl: { type: "READY", startingId: thumbnailId } });
      }
    };
    // Light as in light video player
    this.getLightProps = () => {
      const { isLight } = this.props;
      if (!isLight) {
        return {
          isLight: false
        };
      }
      const thumbnail = this.state.thumbnailUrl;
      const url = thumbnail.type === "READY" ? thumbnail.loadedUrl : void 0;
      return { isLight: true, thumbnail: url };
    };
    this.getUrl = () => {
      const { url } = this.state;
      return url.type === "READY" ? url.loadedUrl : void 0;
    };
    this.state = {
      isLoaded: false,
      isVideoWrapperAttachedToDom: false,
      url: this.getInitialUrlState(),
      thumbnailUrl: this.getInitialThumbnailUrlState()
    };
  }
  componentDidMount() {
    this.setState({ key: "mounted" });
    this.setUrl();
    this.setThumbnailUrl();
  }
  componentDidUpdate() {
    const { isVideoWrapperAttachedToDom } = this.state;
    this.setUrl();
    this.setThumbnailUrl();
    if (!isVideoWrapperAttachedToDom) {
      const videoRatio = this.getVideoRatio();
      if (videoRatio) {
        this.setVideoRatio(videoRatio.ratio, videoRatio.wrapper);
        this.setState({ isVideoWrapperAttachedToDom: true });
      }
    }
  }
  getVideoRatio() {
    var _a;
    const wrapper = (_a = ReactDOM.findDOMNode(this)) == null ? void 0 : _a.parentNode;
    if (!wrapper) {
      return void 0;
    }
    const element = wrapper.querySelector("iframe, video");
    if (!element) {
      return void 0;
    }
    const ratio = element.clientHeight / element.clientWidth;
    return !isNaN(ratio) ? { ratio, wrapper } : void 0;
  }
  setVideoRatio(ratio, wrapper) {
    wrapper.style["padding-bottom"] = ratio * 100 + "%";
  }
  render() {
    var _a, _b;
    const { disabled, onDuration, settings, muted, componentData, seoMode } = this.props;
    const { key } = this.state;
    const url = this.getUrl();
    const isLoaded = this.props.isLoaded || this.state.isLoaded;
    const isCustomVideo = !!((_b = (_a = componentData.video) == null ? void 0 : _a.src) == null ? void 0 : _b.id);
    const shouldRenderIframe = isSSR() && seoMode && url;
    const {
      autoPlay = false,
      playInLoop = false,
      showControls = true
    } = componentData.options || {};
    if (!url) {
      return null;
    }
    return shouldRenderIframe ? /* @__PURE__ */ React.createElement(IframePlayer, { isCustomVideo, url }) : /* @__PURE__ */ React.createElement(
      ReactPlayerWrapper,
      __spreadValues(__spreadValues({
        className: styles.video_player,
        onContextMenu: this.handleContextMenu,
        controls: this.props.isLoaded !== false && showControls,
        url,
        onReady: this.onReactPlayerReady,
        disabled,
        width: "100%",
        height: "100%",
        key,
        onDuration,
        onProgress: this.onProgress,
        progressInterval: settings.progressInterval || 1e3,
        muted: muted || autoPlay,
        isLoaded,
        autoPlay,
        loop: playInLoop,
        isCustomVideo
      }, this.getLightProps()), this.disableDownloadProps())
    );
  }
}

export { VideoViewer as V, styles as s };
//# sourceMappingURL=video-viewer-c1024948.js.map
